export var trackerTheme = {
  baseStyle: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  variants: {
    horizontal: {
      flexDirection: 'row'
    },
    vertical: {
      flexDirection: 'column'
    }
  }
};
//# sourceMappingURL=Tracker.theme.js.map